import { render } from "./WhatsApp.vue?vue&type=template&id=20111702&scoped=true"
import script from "./WhatsApp.vue?vue&type=script&lang=js"
export * from "./WhatsApp.vue?vue&type=script&lang=js"

import "./WhatsApp.vue?vue&type=style&index=0&id=20111702&scoped=true&lang=scss"
import "./WhatsApp.vue?vue&type=style&index=1&id=20111702&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20111702"]])

export default __exports__